import Comp from '../../../../../../ManagementApp/wwwroot/client/src/views/components/ProjectIntegrationSystemBadge.vue';
export default Comp;
